'use es6';

import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import CalleeNumberOptions from './CalleeNumberOptions';
import { jsx as _jsx } from "react/jsx-runtime";
function CalleeOptions({
  appIdentifier,
  editPermissionsResults,
  callableObjectList,
  onEditProperty,
  onSelectToNumber,
  disabled,
  OptionIcon,
  onAddPropertyClick,
  showCalleeNames,
  disabledTooltipMessage,
  showAddPropertyButton,
  gates
}) {
  const callableObjectArray = useMemo(() => callableObjectList.toArray(), [callableObjectList]);
  return /*#__PURE__*/_jsx("div", {
    className: "m-top-2",
    "data-selenium-test": "callee-options",
    children: callableObjectArray.map(callableObject => {
      return /*#__PURE__*/_jsx(CalleeNumberOptions, {
        appIdentifier: appIdentifier,
        editPermissionsResults: editPermissionsResults,
        callableObject: callableObject,
        onEditProperty: onEditProperty,
        onSelectToNumber: onSelectToNumber,
        disabled: disabled,
        OptionIcon: OptionIcon,
        onAddPropertyClick: onAddPropertyClick,
        showCalleeNames: showCalleeNames,
        showAddPropertyButton: showAddPropertyButton,
        disabledTooltipMessage: disabledTooltipMessage,
        gates: gates
      }, callableObject.hashCode());
    })
  });
}
CalleeOptions.propTypes = {
  appIdentifier: PropTypes.string.isRequired,
  onEditProperty: PropTypes.func,
  onSelectToNumber: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  editPermissionsResults: ImmutablePropTypes.map,
  callableObjectList: ImmutablePropTypes.orderedMap,
  OptionIcon: PropTypes.object,
  onAddPropertyClick: PropTypes.func,
  showCalleeNames: PropTypes.bool.isRequired,
  disabledTooltipMessage: PropTypes.string,
  showAddPropertyButton: PropTypes.bool.isRequired,
  gates: PropTypes.arrayOf(PropTypes.string)
};
CalleeOptions.defaultProps = {
  editPermissionsResults: null
};
export default /*#__PURE__*/memo(CalleeOptions);